import { connect } from 'react-redux'
import SignOutProcess from './sign-out-process'
import { withMe } from 'pobble-components/dist/pobble-user'
import { apiLogout } from '../../../../common/api/profile'
import { withRouter } from 'react-router'
import { URLS } from 'pobble-components/dist/setup'

const mapStateToProps = (state, { me, history }) => {
  if (!me) {
    return {}
  }
  apiLogout()
  window.location.replace(URLS.MARKETING)
  return {}
}

export default withRouter(
  withMe(
    connect(
      mapStateToProps,
      null
    )(SignOutProcess)
  )
)
